import { render, staticRenderFns } from "./ChallengeAndLeagueSelector.vue?vue&type=template&id=26064492&"
import script from "./ChallengeAndLeagueSelector.vue?vue&type=script&lang=js&"
export * from "./ChallengeAndLeagueSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports